
import axios from 'axios'
/* ======================= Funciones ======================= */

export const axiosCall = (options) => {
    return axios(options)
}